import React, { Component } from 'react';
import ReactPlayer from 'react-player';

import AppLink from "./AppLink.js";
import PlaceInfo from "./PlaceInfo.js";
import PlaceInfoButton from "./PlaceInfoButton.js";
import CategoryButtons from './CategoryButtons.js';
import C from "../config/Constants.js";

class VideoComponent extends Component {
    constructor(props) {
        super(props);

        this.onStoryStart = this.onStoryStart.bind(this)
        this.onClickAmbiFunc = this.onClickAmbiFunc.bind(this)
        this.onClickFDFunc = this.onClickFDFunc.bind(this)
        this.onEnded = this.onEnded.bind(this)
        this.onLeft = this.onLeft.bind(this)
        this.onProgress = this.onProgress.bind(this)
        this.prepTransition = this.prepTransition.bind(this)
        this.onClickPlaceInfo = this.onClickPlaceInfo.bind(this)
        this.onClosePlaceInfo  = this.onClosePlaceInfo.bind(this)

        var isIframe = window.location !== window.parent.location
        var isMobile = /webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(
            navigator.userAgent
        )
        
        this.state = {
            videos: this.props.videos,
            showLink: false,
            showPlaceInfo: false,
            index: 0,
            playing: true,
            proof: null,
            muted: (isIframe || isMobile),
            // proof: {`Playing ${playing} | # ${index}`}
        };
    }

    onClickPlaceInfo () {
        this.setState({playing: false, showPlaceInfo: true})
    }

    onClosePlaceInfo () {
        this.setState({playing: true, showPlaceInfo: false})
    }
  
    onClickAmbiFunc() {
        this.prepTransition(0)
    }

    onClickFDFunc() {
        var { videos } = this.props;

        var firstFDVidIndex = this.props.videos.length + 1 - C.NUM_VIDS_PER_PHASE
        var searchFirstIndex = videos.indexOf((vid) => vid['phase'] === 'foodDrink');
        if (searchFirstIndex > 0) {
            firstFDVidIndex = searchFirstIndex
        }

        this.prepTransition(firstFDVidIndex);
    }

    onStoryStart() {
        this.setState({playing: true})
    }

    onEnded() {
        var { index } = this.state
        if (index < this.props.videos.length-1) {
            this.prepTransition(index+1)
        } else {
            this.prepTransition(0)
        }
    }

    onLeft() {
        var { index } = this.state
        if (index > 0) {
            this.prepTransition(index-1)
        } else {
            this.prepTransition(this.props.videos.length - 1)
        }
    }

    onProgress(progress) {
        var { index, videos } = this.state

        var nextIndex = 0, link=null, cont=progress
        if (index < this.props.videos.length-1) {
            nextIndex = index+1
        } else {
            nextIndex = 0
        }

        if (!!videos && !!videos[nextIndex]) {
            link = <video rel="preload" preload="auto" as="video" href={videos[nextIndex].url}></video>
            cont = {playedPercent: progress.played, link: videos[nextIndex].url}
        }

        if (progress.played > 0.95) {
            this.prepTransition(nextIndex)
        }

        this.setState({proof: cont, link})
    }

    // Basically pause the video when we transition and restart it just before we expect to have it ready. Terrible...
    prepTransition(index) {
        this.setState({index, playing: true})
        setTimeout(this.onStoryStart, 400);
    }

    render() {
        var { videos, place, options } = this.props
        var { index, showLink, playing, showPlaceInfo, proof, muted } = this.state

        // Always show app link if we're done or no videos 
        if (showLink || videos.length <= index || videos.length === 0  || videos[0]["place"] == undefined ) {
            return <AppLink />
        }

        if (showPlaceInfo) {
            return <PlaceInfo data={{place}} close={this.onClosePlaceInfo} />
        }

        return (
            <div>
                {/* { proof && <a>{JSON.stringify(proof)}</a> } */}
                <CategoryButtons 
                    video={videos[index]} 
                    onClickLeft={this.onLeft} 
                    onClickRight={this.onEnded} 
                    onClickAmbi={this.onClickAmbiFunc} 
                    onClickFD={this.onClickFDFunc}
                    showPhases={options["phases"]}
                    index={index}
                />
                { !!options['placeInfo'] && <PlaceInfoButton toggleMore={this.onClickPlaceInfo} /> }
                <ReactPlayer 
                    width="100%"
                    height="100vh"
                                    
                    url={videos[index].url} 
                    // Mobile browers wont let you autoplay unless you're muted
                    muted={true}
                    autoplay={true}
                    playsinline={true}
                    loop={true}
                    playing={playing}
                    progressInterval={C.PROGRESS_INTERVAL_MS}

                    onEnded={this.onEnded}
                    onReady={this.onStoryStart}
                    onProgress={this.onProgress}
                />
                {this.state.link}
            </div>

        );
    }
  }

export default VideoComponent;